export var edges = ['top', 'right', 'bottom', 'left'];
export var edgeAxisLookup = {
  top: 'vertical',
  right: 'horizontal',
  bottom: 'vertical',
  left: 'horizontal'
};